import { useState, useEffect } from "react";
import { apiPublic } from "../api/robyBackend";
import { Link } from "react-router-dom";

export default function ResetPassword() {
  const params = new URLSearchParams(window.location.search);
  const uid = params.get("uid");
  const token = params.get("token");

  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!uid || !token) setMsg("Ungültiger Reset-Link.");
  }, [uid, token]);

  // Passwort-Checks
  const checks = {
    length: password.length >= 8,
    upper: /[A-Z]/.test(password),
    number: /\d/.test(password),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    match: password && password === password2,
  };
  const allValid = Object.values(checks).every(Boolean);

  const submit = async (e) => {
    e.preventDefault();
    setMsg("");

    if (!uid || !token) {
      setMsg("Ungültiger Reset-Link.");
      return;
    }
    if (!allValid) {
      setMsg("Bitte erfülle alle Passwort-Anforderungen.");
      return;
    }

    setBusy(true);
    try {
      const res = await apiPublic.post("/api-roby/password-reset-confirm/", {
        uid,
        token,
        new_password: password,
      });
      setMsg(res?.data?.detail || "Passwort erfolgreich gesetzt. Du kannst dich jetzt einloggen.");
    } catch (err) {
      const apiMsg =
        err?.response?.data?.detail || "Fehler beim Zurücksetzen. Der Link ist evtl. ungültig oder abgelaufen.";
      setMsg(apiMsg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Neues Passwort setzen</h2>

        {!uid || !token ? (
          <p className="error">{msg}</p>
        ) : (
          <form onSubmit={submit}>
            <input
              type="password"
              placeholder="Neues Passwort (mind. 8 Zeichen)"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoFocus
            />

            <input
              type="password"
              placeholder="Passwort wiederholen"
              value={password2}
              onChange={(e) => setPassword2(e.target.value)}
              required
            />

            {/* Passwort-Checkliste im gleichen Stil */}
            <ul className="pw-checklist">
              <li className={checks.length ? "ok" : "bad"}>
                {checks.length ? "✓" : "✗"} Mindestens 8 Zeichen
              </li>
              <li className={checks.upper ? "ok" : "bad"}>
                {checks.upper ? "✓" : "✗"} Mindestens ein Großbuchstabe
              </li>
              <li className={checks.number ? "ok" : "bad"}>
                {checks.number ? "✓" : "✗"} Mindestens eine Zahl
              </li>
              <li className={checks.special ? "ok" : "bad"}>
                {checks.special ? "✓" : "✗"} Mindestens ein Sonderzeichen
              </li>
              <li className={checks.match ? "ok" : "bad"}>
                {checks.match ? "✓" : "✗"} Passwörter stimmen überein
              </li>
            </ul>

            <button type="submit" disabled={!allValid || busy}>
              {busy ? "Speichere…" : "Passwort setzen"}
            </button>

            {msg && (
              <p className={msg.includes("erfolgreich") ? "info" : "error"} style={{ marginTop: 10 }}>
                {msg}
              </p>
            )}
          </form>
        )}

        <div className="forgot-password" style={{ marginTop: 16 }}>
          <Link to="/login">Zurück zum Login</Link>
        </div>
      </div>
    </div>
  );
}
